import {
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
} from '@material-ui/core';
import { ToggleIcon } from '../index';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useState } from 'react';
import { useFormValidation } from '../../hooks/useFormValidation';
import { LoginFormButtons } from './LoginFormButtons';

export const LoginForm = (props: LoginFormFieldsProps) => {
  const { loading, login, onForgotPassword } = props;
  const [showPassword, setShowPassword] = useState(false);
  const { onChange, onSubmit, resetForm, values } = useFormValidation(
    {
      username: {
        value: '',
      },
      password: {
        value: '',
      },
    },
    () =>
      login(
        values.username.value,
        values.password.value,
        (success: boolean) => {
          if (success) resetForm();
        }
      )
  );
  const classes = useStyles();

  const handlePasswordVisibility = () => {
    setShowPassword((showPassword) => !showPassword);
  };

  return (
    <form onSubmit={onSubmit}>
      <Grid className={classes.inputs} container direction="column" spacing={2}>
        <Grid item>
          <TextField
            autoFocus
            fullWidth
            id="username"
            InputProps={{ className: classes.input }}
            label="Email Address"
            name="username"
            onChange={onChange}
            type="email"
            required
            value={values.username.value}
          />
        </Grid>
        <Grid item>
          <TextField
            fullWidth
            id="password"
            InputProps={{
              className: classes.input,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    className={classes.iconButton}
                    disableRipple
                    disableFocusRipple
                    onClick={handlePasswordVisibility}
                  >
                    <ToggleIcon
                      on={showPassword}
                      onIcon={<Visibility />}
                      offIcon={<VisibilityOff />}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            label="Password"
            name="password"
            onChange={onChange}
            required
            type={showPassword ? 'text' : 'password'}
            value={values.password.value}
          />
        </Grid>
      </Grid>
      <LoginFormButtons
        onForgotPassword={onForgotPassword}
        loading={loading}
        formValues={values}
      />
    </form>
  );
};

const useStyles = makeStyles(() => ({
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  inputs: {
    margin: '15px 0px',
    width: '100%',
  },
  input: {
    paddingLeft: '8px',
  },
}));
